export const convertM3u8ToMp4 = (url) => {
  let mp4Url = url.replace(
    process.env.REACT_APP_M3U8_BUCKET || "",
    process.env.REACT_APP_MP4_BUCKET || ""
  );
  mp4Url = mp4Url.replace(".m3u8", ".mp4");
  return mp4Url;
};
